import { ADMIN_ROLE } from "@drs-ops/access";
import { useAccess } from "@drs-ops/access/frontend";

/** UI hint only — the Worker enforces every role (worker/middleware/auth.ts guardRoute). */
export function useIsAdmin(): boolean {
  return useAccess().data?.roles.includes(ADMIN_ROLE) ?? false;
}

/** Mirrors guardRoute's trip-planner entry: admin or estimator. */
export function useCanEstimate(): boolean {
  const roles = useAccess().data?.roles ?? [];
  return roles.includes(ADMIN_ROLE) || roles.includes("estimator");
}
